import React, { lazy, Suspense } from 'react';

const LazyDeveloperList = lazy(() => import('./DeveloperList'));

const DeveloperList = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode },
) => (
  <Suspense fallback={null}>
    <LazyDeveloperList {...props} />
  </Suspense>
);

export default DeveloperList;
